// Résolution de l'URL backend
// Priorité 1 : window.APP_CONFIG.apiUrl (éditable sur le serveur, sans rebuild)
//   '' (vide) = URLs relatives /api/ → nginx proxy → backend local (production)
//   'https://...' = URL absolue → backend distant (si besoin)
// Priorité 2 : REACT_APP_BACKEND_URL (baked-in au build, fallback si config.js absent)
const configUrl = window.APP_CONFIG?.apiUrl;
const backendUrl = (configUrl !== undefined && configUrl !== null)
  ? configUrl
  : (process.env.REACT_APP_BACKEND_URL || '');

export const API = `${backendUrl}/api`;
